import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { node_server } from "../constants";
import {
	setData,
	setDiscoverItems,
	setFavorites,
	setHasMore,
	setIsLoading,
	setPage,
	setProjectFavorites,
	setProjectItems,
	setProjects,
	setRemoving,
} from "../store/slices/profile/discoverSlice";

function useDiscover(noEffects = false) {
	const ITEMS_PER_PAGE = 5;

	const { pathname } = useLocation();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.user.value);
	const {
		favorites,
		data,
		discoverItems,
		projectItems,
		page,
		hasMore,
		isLoading,
	} = useSelector((state) => state.discover);

	const [bottomReached, setBottomReached] = useState(false);

	const deleteShoutout = async (client) => {
		try {
			const response = await axios.post(
				`${node_server}/api/shoutouts/cancel`,
				{
					receiverId: client.matched_user_id,
				},
				{
					withCredentials: true,
				},
			);

			if (response.status !== 200) {
				console.error("Error deleting shoutout:", response.data);
			} else {
				const filterdFav = favorites.filter(
					(item) => item.receiver_id !== client.matched_user_id,
				);

				dispatch(setFavorites(filterdFav));
				dispatch(
					setData([
						...data.map((item) =>
							item === client
								? { ...item, shout_outed: false }
								: item,
						),
					]),
				);

				const response = await axios.post(
					`${node_server}/api/user-feed/update`,
					{
						matched_user_id: client.matched_user_id,
						shout_outed: false,
					},
					{
						withCredentials: true,
					},
				);

				if (response.status !== 200) {
					console.error("Error updating feed:", response.data);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const insertShoutout = async (client) => {
		try {
			if (client.shout_outed === false) {
				const response = await axios.post(
					`${node_server}/api/shoutouts/create`,
					{
						receiverId: client.matched_user_id,
					},
					{
						withCredentials: true,
					},
				);

				if (response.status !== 200) {
					console.error(response.data);
				} else {
					dispatch(
						setData([
							...data.map((item) =>
								item === client
									? { ...item, shout_outed: true }
									: item,
							),
						]),
					);

					const response = await axios.post(
						`${node_server}/api/user-feed/update`,
						{
							matched_user_id: client.matched_user_id,
							shout_outed: true,
						},
						{
							withCredentials: true,
						},
					);

					if (response.status !== 200) {
						console.error("Error updating feed:", response.data);
					}
				}
			}
		} catch (error) {
			console.error("Unexpected error:", error);
		}
	};

	const handleCloseProject = async (project) => {
		if (project.key === "project") {
			// const filteredProjects = data.filter(
			//   (item) => item.project_id !== project.project_id
			// );
			// dispatch(setData(filteredProjects));

			// Remember to handle the combined feed behavior .. Good Bye :)
			const filtered = projectItems.map((item) => {
				if (item?.project_id === project?.project_id) {
					return null;
				} else {
					return item;
				}
			});
			dispatch(setProjectItems(filtered));

			const response = await axios.delete(
				`${node_server}/api/project-feed/${project.project_id}`,
				{
					withCredentials: true,
				},
			);

			if (response.status === 200) {
				try {
					const response = await axios.post(
						`${node_server}/api/projects/exclude`,
						{
							projectId: project.project_id,
						},
						{ withCredentials: true },
					);
					if (response.status !== 200) {
						console.error(response.data);
					}
				} catch (e) {
					console.error(e);
				}
			} else {
				console.error(response.data);
			}
		} else if (project.key === "user") {
			// const filteredProjects = data.filter(
			//   (item) => item.matched_user_id !== project.matched_user_id
			// );
			// dispatch(setData(filteredProjects));

			// Remember to handle the combined feed behavior .. Good Bye :)
			const filtered = discoverItems.map((item) => {
				if (item?.matched_user_id === project?.matched_user_id) {
					return null;
				} else {
					return item;
				}
			});
			dispatch(setDiscoverItems(filtered));

			const { data: deleteResponse } = await axios.post(
				`${node_server}/api/user-feed/delete`,
				{
					matched_user_id: project.matched_user_id,
				},
				{
					withCredentials: true,
				},
			);
			const error = !deleteResponse?.success;

			if (!error) {
				try {
					const response = await axios.post(
						`${node_server}/api/user/exclude`,
						{
							userId: project.user_id,
							excludedUserId: project.matched_user_id,
						},
						{ withCredentials: true },
					);
					if (response.status !== 200) {
						console.error(response.data);
					}
				} catch (e) {
					console.error(e);
				}
			} else {
				console.error(error);
			}
		}
	};

	const handleSwipeLeft = async (client) => {
		// console.log("Swiped left on:", client);
		// Handle left swipe action (e.g., delete client)
		// if ( client.key === "user") {
		//     await insertShoutout(client);
		// }
	};

	const handleSwipeRight = (card) => {
		dispatch(setRemoving(card));
		setTimeout(() => {
			handleCloseProject(card);
			dispatch(setRemoving(null));
		}, 300);
	};

	const fetchDiscoverData = async (page) => {
		try {
			dispatch(setIsLoading(true));
			const { data: discoverData, error: discoverError } =
				await axios.get(`${node_server}/api/user-feed?page=${page}`, {
					withCredentials: true,
				});

			if (discoverError) console.log(discoverError);
			if (discoverData)
				dispatch(setDiscoverItems([...discoverItems, ...discoverData]));

			const response = await axios.get(
				`${node_server}/api/project-feed?page=${page}`,
				{
					withCredentials: true,
				},
			);
			const projectData = response.data;

			if (response.status !== 200) console.log(response.data);
			if (projectData)
				dispatch(setProjectItems([...projectItems, ...projectData]));

			dispatch(
				setHasMore(
					discoverData?.length === ITEMS_PER_PAGE ||
						projectData?.length === ITEMS_PER_PAGE,
				),
			);
		} catch (error) {
			console.error("Unexpected error:", error);
		} finally {
			dispatch(setIsLoading(false));
			setBottomReached(false);
		}
	};

	const combineDiscoveryFeed = () => {
		if (isLoading) return;
		dispatch(setIsLoading(true));
		const combinedData = [];
		const maxLength = Math.max(discoverItems?.length, projectItems?.length);
		for (let i = 0; i < maxLength; i++) {
			if (i < discoverItems.length) {
				if (discoverItems[i] !== null) {
					combinedData.push({ ...discoverItems[i], key: "user" });
				}
			}
			if (i < projectItems.length) {
				if (projectItems[i] !== null) {
					combinedData.push({ ...projectItems[i], key: "project" });
				}
			}
		}

		dispatch(setData([...combinedData]));
		dispatch(setIsLoading(false));
	};

	useEffect(() => {
		if (noEffects) return;

		const fetchShoutOuts = async () => {
			const response = await axios.get(
				`${node_server}/api/shoutouts/given`,
				{
					withCredentials: true,
				},
			);

			if (response.status === 200 && response.data.length > 0) {
				dispatch(setFavorites(response.data));
			}
		};

		const fetchProjectFavorites = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/projects/favourite`,
				{
					withCredentials: true,
				},
			);
			if (error) console.log(error);
			if (data) dispatch(setProjectFavorites(data));
		};

		const fetchData = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/projects/user-info`,
				{
					withCredentials: true,
				},
			);
			
			if (error) console.error(error);
			if (data) dispatch(setProjects(data));
		};

		if (user) {
			fetchData();
			fetchShoutOuts();
			fetchProjectFavorites();
		}
	}, [user]);

	useEffect(() => {
		if (noEffects) return;

		if (user?.id) {
			dispatch(setData([]));
			dispatch(setHasMore(true));
			dispatch(setPage(1));
		}
	}, [user]);

	useEffect(() => {
		if (noEffects) return;
		fetchDiscoverData(page);
	}, [page]);

	useEffect(() => {
		combineDiscoveryFeed();
	}, [discoverItems, projectItems]);

	useEffect(() => {
		const handleScroll = () => {
			if (pathname === "/discover/results" && !isLoading && hasMore) {
				if (
					window.innerHeight + window.scrollY ===
					document.documentElement.scrollHeight
				) {
					// setBottomReached(true);
					dispatch(setPage(page + 1));
				}
			}
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [pathname, data]);

	return {
		deleteShoutout,
		insertShoutout,
		handleSwipeLeft,
		handleSwipeRight,
		fetchDiscoverData,
		handleCloseProject,
	};
}

export default useDiscover;
